import React from "react";
import { Link } from "react-router-dom";
import { nanoid } from "nanoid";

import Image from "../imageComponent";

import { ProductCardInterface, CardDataInterface } from "../../interfaces";
import { cartFillSvg, box3DSvg } from "../../svgs";

import { CardWrapper } from "./styled";

const ProductCard: React.FC<ProductCardInterface> = ({
  productData,
  prefetch,
  ...props
}: CardDataInterface) => {
  // translation

  return (
    <CardWrapper {...props}>
      <div className="actions">
        {/* <a
          href={`https://veli.store/details/${encodeURIComponent(productData.link.replace(/ /g, '-'))}${
            productData.sku ? `?sku=${productData.sku}` : ''
          }`}
          className="add-to-cart"
        >
          {cartFillSvg()}
        </a> */}
      </div>
      {/* image  */}
      <a
        href={productData.link}
        key={nanoid()}
        className="img-box"
        target="_blank"
        rel="noreferrer"
      >
        <Image
          className="img"
          priority={prefetch}
          src={productData.src}
          alt={productData.headline}
          layout="fill"
          contain
        />

        {/* sale banner (%)  */}
        {Number(productData.new_price) < Number(productData?.old_price) ? (
          <h4 className="sale">
            -
            {(
              100 -
              (Number(productData.new_price) / Number(productData.old_price)) *
                100
            ).toFixed(0)}
            %
          </h4>
        ) : null}
      </a>
      {/* main  */}
      <div className="info">
        <div className="prices">
          <span className="price">
            {Number(productData.new_price).toFixed(2)} ₾
          </span>

          {productData.old_price && (
            <span className="old-price">
              {Number(productData.old_price).toFixed(2)} ₾
            </span>
          )}
        </div>

        <div className="author">{productData.author || productData.brand}</div>

        <div className="title">
          <a target="_blank" rel="noreferrer" href={productData.link}>
            {productData.name}
          </a>
        </div>
      </div>

      {/* flex end  */}
      {/* <div className="end">
        <div className="free-delivery">{box3DSvg()} უფასო მიწოდება</div>
          
      </div> */}
    </CardWrapper>
  );
};
export default ProductCard;
